
import { defineComponent } from 'vue'
import { parseMessage } from '@/utils/parseMessage';
import axios from 'axios';
import ChatPeopleBar from '@/components/ChatPeopleBar.vue';
import EmojiPicker from 'vue3-emoji-picker'
import io from 'socket.io-client';

type Message = {
	_id: number;
	author: string;
	message: string;
	isRead: boolean
	createdAt: Date;
	status: string;
	updated_at: string;
};

type Chat = {
	_id: number
	messages: Message[]
}

type Person = {
	_id: number
	wpId?: number,
	id: number,
	url: string,
	firstName?: string,
	lastName?: string,
	image: {
		src: string,
		alt: string
	},
	name: string,
	active?: boolean,
	chatRooms?: string[],
	unreadMessage?: number
	online?: boolean
}

type Friend = {
	blockFriend: boolean,
	_id: Person
}

export default defineComponent({
	/* eslint-disable */
	name: 'HomeView',
	components: {
		ChatPeopleBar,
		EmojiPicker
	},
	data(){
		return {
			isLoading: false,
			rooms: [],
			peopleList: [] as Person[],
			newMessage: '',
			messages: [] as Message[],
			user: {
				uid: 1
			},
			socket: io(''),
			currentUser: null as Person | null,
			users: [],
			msg: '',
			currentChat: {} as Chat
		};
	},
	computed: {
		getPeopleList(){
			return this.peopleList.filter((people) => people.wpId !== this.user.uid).sort((a: Person, b: Person) => {
				const unreadMessagesA = a.unreadMessage || 0;
				const unreadMessagesB = b.unreadMessage || 0;

				return unreadMessagesB - unreadMessagesA;
			})
		},
		getCurrentChat(){
			return this.getPeopleList.find((people) => people.active)
		},
		getFullName(){
			return this.getCurrentChat?.firstName + ' ' + this.getCurrentChat?.lastName || ''
		}
	},
	created(){
		this.socket = io(`${process.env.VUE_APP_BASE_API_URI_SOCKET}`)
		this.socket.on('connect', () => {
			console.log('Connected to the server');
		});
	},
	async mounted(){
		this.isLoading = true
		await this.getUserFromWp()
		await this.getUser()
		await this.getChat()
		await this.markMessagesAsRead()
		await this.getUnreadMessages()
		this.socket.emit('join', { user: this.currentUser?._id })
		this.socket.emit('joinRoom', { room: this.currentChat?._id })

		this.socket.on('updateOnlineUsers', (onlineUsers) => {
			this.peopleList.forEach(person => {
				const matchingUser = onlineUsers.find((user: {socketId: string, user: number}) => user.user === person._id);
				person.online = !!matchingUser;
			});
		});

		this.socket.on('message', (message: Message) => {
			this.currentChat.messages.unshift(message)
			// this.updateMessage(message._id)
		});

		this.socket.on('allMessages', (data) => {
			this.peopleList = this.peopleList.map(person => {
				if (Array.isArray(person.chatRooms) && person.chatRooms.includes(data.chatId) && data.chatId !== this.currentChat._id){
					person.unreadMessage = data.messages;
				}
				return person;
			});
		});
		this.isLoading = false
	},
	methods: {
		async sendMessage(){
			try {
				if (this.newMessage.trim() !== ''){
					await axios.post(`${process.env.VUE_APP_BASE_API_URI}/chat/${this.currentChat?._id}/send`, {
						author: this.currentUser?._id,
						message: this.newMessage.trim(),
						recipient: this.getCurrentChat?._id
					});
					(this.$refs.messageForm as HTMLFormElement).reset();
				}
			} catch (err){
				console.log(err)
			}
		},

		async getUserFromWp(){
			try {
				const res = await axios.get('/api/get_current_user.php')
				this.user.uid = res.data.wpId
			} catch (err){
				console.log(err)
			}
		},

		async getUser(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/users/${this.user?.uid}`)
				const routeId = Number(this.$route.query.id);
				this.currentUser = res.data
				this.peopleList = res.data.friends.filter((el: Friend) => !el.blockFriend).map((el: Friend) => ({
					...el._id,
					active: Number(el._id.wpId) === routeId,
					unreadMessage: 0
				}));
			} catch (err){
				console.log(err)
			}
		},

		async markMessagesAsRead(){
			await axios.put(`${process.env.VUE_APP_BASE_API_URI}/chat/${this.currentUser?._id}/${this.getCurrentChat?._id}/read`)
		},

		async getChat(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/chat/${this.currentUser?._id}/${this.getCurrentChat?._id}`)
				this.currentChat = res.data
			} catch (err){
				console.log(err)
			}
		},

		async getUnreadMessages(){
			try {
				const response = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/chat/${this.currentUser?._id}`);
				const messages = response.data;

				const friendsMap = new Map(this.peopleList?.map((friend) => [String(friend._id), friend]));

				messages.forEach((message: Message) => {
					const friend = friendsMap.get(String(message.author));
					if (friend){
						friend.unreadMessage = (friend.unreadMessage || 0) + 1;
					}
				});
			} catch (err){
				console.error(err);
			}
		},

		async updateMessage(id: number){
			try {
				await axios.put(`${process.env.VUE_APP_BASE_API_URI}/chat/message/${id}`);
			} catch (err){
				console.error(err);
			}
		},

		parseMessage(message: string){
			return parseMessage(message || '')
		}
	},
	unmounted(){
		if (this.socket){
			this.socket.disconnect();
			console.log('Socket.IO connection closed');
		}
	}
})
